import React, { useEffect } from "react";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { getDevToolIcon } from "@/components/utils/taskCreationUtils";

export type DevTool = "jira" | "asana" | "monday" | "productboard";

interface DevToolSelectProps {
  value: DevTool;
  onChange: (value: DevTool) => void;
}

const DevToolSelect = ({ value, onChange }: DevToolSelectProps) => {
  useEffect(() => {
    // Broadcast the selected DevTool value immediately when it changes
    const event = new CustomEvent('devToolChange', { detail: value });
    window.dispatchEvent(event);
  }, [value]);

  return (
    <div className="flex flex-col gap-3">
      <span className="text-sm font-medium">Send Tasks To</span>
      <Select 
        value={value} 
        onValueChange={(value: DevTool) => onChange(value)}
      >
        <SelectTrigger className="w-full bg-white">
          <SelectValue placeholder="Select destination" />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            <SelectItem value="jira">
              <div className="flex items-center gap-2">
                <img src={getDevToolIcon('jira')} alt="Jira" className="h-4 w-auto" />
                Jira
              </div>
            </SelectItem>
            <SelectItem value="asana">
              <div className="flex items-center gap-2">
                <img src={getDevToolIcon('asana')} alt="Asana" className="h-4 w-auto" />
                Asana
              </div>
            </SelectItem>
            <SelectItem value="monday">
              <div className="flex items-center gap-2">
                <img src={getDevToolIcon('monday')} alt="Monday" className="h-4 w-auto" />
                Monday
              </div>
            </SelectItem>
            <SelectItem value="productboard">
              <div className="flex items-center gap-2">
                <img src={getDevToolIcon('productboard')} alt="ProductBoard" className="h-4 w-auto" />
                ProductBoard
              </div>
            </SelectItem>
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
};

export default DevToolSelect;
